import React from "react";
import { Spin } from "antd";
import { useAuth } from "../../context/AuthContext";
import { isZoomEmbeddedApp } from "../../utilities/postLoginRoute";
import AuthContainerPage from "../../pages/auth/AuthContainerPage";
import DummyFirstPage from "../../pages/auth/DummyFirstPage";
import RoleBasedRedirect from "./RoleBasedRedirect";

/**
 * Root route handler. Zoom's embedded browser requires the Home URL to return
 * HTTP 200. Use https://911interpreterscrm.com/ as the Zoom Home URL so this
 * route runs the Zoom OAuth entry flow without hitting /dummy/ (which 404s on
 * reload until Amplify SPA rewrites are fixed).
 */
const RootRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Spin spinning fullscreen />;
  }

  if (isZoomEmbeddedApp() && !user) {
    return (
      <AuthContainerPage>
        <DummyFirstPage />
      </AuthContainerPage>
    );
  }

  return <RoleBasedRedirect />;
};

export default RootRoute;
